import { AppBar, Toolbar, Typography, Button, Avatar, Menu, MenuItem, Divider } from '@mui/material';
import { useIsAuthenticated  } from '@azure/msal-react'
import { useCallback, useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react'
import { useAppDispatch, useAppSelector } from '../../Services/Store';
import { getUserData, selectIsLoaded, selectUserPicture, selectUserProfile } from '../../Services/Store/Slices/UserSlice';
import { UpdateWikiDialog } from '../UpdateWikiDialog';
import { GetWikiStatusDialog } from '../GetWikiStatusDialog';
import UpdateIcon from '@mui/icons-material/Update';
import LogoutIcon from '@mui/icons-material/Logout';

export const TopBar = () => {
  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);
  const [isStatusDialogOpen, setIsStatusDialogOpen] = useState(false);
  const msalContext = useMsal();
  const dispatch = useAppDispatch();
  const userProfile = useAppSelector(selectUserProfile);
  const userPicture = useAppSelector(selectUserPicture);
  const userIsLoaded = useAppSelector(selectIsLoaded);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isAuthenticated = useIsAuthenticated();
  const handleMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    handleClose();
    msalContext.instance.logoutRedirect();
  };
  const handleUpdateDialogOpen = useCallback((): void => {
    setIsUpdateDialogOpen(true);
  }, []);
  const handleUpdateDialogClose = useCallback((): void => {
    setIsUpdateDialogOpen(false);
  }, []);

  const handleStatusDialogOpen = useCallback((): void => {
    setIsStatusDialogOpen(true);
  }, []);
  const handleStatusDialogClose = useCallback((): void => {
    setIsStatusDialogOpen(false);
  }, []);

  useEffect(() => {
    if (!isAuthenticated || userIsLoaded)
      return

    dispatch(getUserData(msalContext));
  }, [isAuthenticated, userIsLoaded, dispatch, msalContext]);

  return(
    <AppBar position='fixed' sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}>
      <Toolbar>
        <Typography variant='h6' noWrap color='inherit' component='div'>
          Wiki
        </Typography>
        <Typography sx={{ flexGrow: 1 }} />
        { isAuthenticated && (
          <div>
            <Button onClick={ handleMenu } color='inherit'>
              <Avatar alt={(!userProfile ? '' : userProfile.displayName)} src={(!userPicture ? '' : userPicture)} sx={{ ...((!isAuthenticated || !userPicture) && { display: 'none' }) }} />
              <Typography variant='h6' sx={{ ...(!userProfile && { display: 'none' }) }} style={{ marginLeft: '10px', marginRight: '10px' }}>
                {(!userProfile ? '' : userProfile.displayName)}
              </Typography>
            </Button>
            <Menu
              id='menu-appbar'
              anchorEl={ anchorEl }
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={ Boolean(anchorEl) }
              onClose={ handleClose }
              MenuListProps={{
                "aria-labelledby": "basic-button",
                sx: { width: anchorEl && anchorEl.offsetWidth }
              }}
            >
              <MenuItem onClick={ handleUpdateDialogOpen }>
                <Button color='primary' startIcon={ <UpdateIcon /> }>
                  Aktualizuj wiki
                </Button>
              </MenuItem>

              <MenuItem onClick={ handleStatusDialogOpen }>
                <Button color='primary' startIcon={ <UpdateIcon /> }>
                  Sprawdź status Wiki
                </Button>
              </MenuItem>

              <Divider />
              <MenuItem onClick={ () => handleLogout() }>
                <Button color='error' startIcon={ <LogoutIcon /> }>
                  Wyloguj
                </Button>
              </MenuItem>
            </Menu>
          </div>
        ) }
      </Toolbar>
      { isAuthenticated && (
        <>
          <UpdateWikiDialog 
            isOpen={ isUpdateDialogOpen } 
            onClose={ handleUpdateDialogClose }
          />
          <GetWikiStatusDialog
            isOpen={isStatusDialogOpen}
            onClose={handleStatusDialogClose}
          />
        </>
      ) }
    </AppBar>
  );
}